module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#group",
      toString: function () {
        return this.url;
      }
    }